import moment from "moment";
import { FormValidationRule } from "../../forms/types";

const isValidDate: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (v) {
        const value = moment(v, "YYYY-MM-DD");
        if (
            !value.isValid() ||
            (typeof v === "string" && v.replaceAll(" ", "").length > 10) ||
            value.year() === 0
        ) {
            valid = false;
            message = "Please enter a valid date.";
        }
    }
    return [valid, message];
};

export default isValidDate;
